import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="container-main py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-shirt-line text-lg"></i>
              </span>
              <span className="text-xl font-bold text-foreground-900 font-heading">
                被护专家
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专业被芯干洗护理品牌，累计服务超过50万家庭。为蚕丝被、羽绒被、美女被等高端被芯提供专业级干洗护理服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">服务分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors no-underline whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <a href="tel:4008886666" className="hover:text-primary-600 transition-colors no-underline whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>400-888-6666
              </a>
              <a href="mailto:service@beizhuanjia.com" className="hover:text-primary-600 transition-colors no-underline whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>service@beizhuanjia.com
              </a>
              <span className="whitespace-nowrap">
                <i className="ri-map-pin-line mr-2"></i>上海市浦东新区碧波路888号
              </span>
              <span className="whitespace-nowrap">
                <i className="ri-time-line mr-2"></i>周一至周日 9:00 - 21:00
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="container-main py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 被护专家 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors no-underline">关于我们</Link>
            <Link to="/category/beixin" className="hover:text-primary-600 transition-colors no-underline">被芯保养</Link>
            <Link to="/" className="hover:text-primary-600 transition-colors no-underline">首页</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}